import { __extends } from "tslib";
import { BaseApiService } from "../../api/baseApiService";
import { request } from "../../api/request";
import { URLS } from "../services.constants";
var LessonCommentsService = (function (_super) {
    __extends(LessonCommentsService, _super);
    function LessonCommentsService(baseUrl) {
        return _super.call(this, baseUrl) || this;
    }
    LessonCommentsService.prototype.commentVote = function (data) {
        return request("".concat(this.baseUrl, "/user-vote"), "POST", this.emptyStringToNull(data));
    };
    LessonCommentsService.prototype.deleteCommentVote = function (data) {
        return request("".concat(this.baseUrl, "/user-vote"), "DELETE", this.emptyStringToNull(data));
    };
    return LessonCommentsService;
}(BaseApiService));
export { LessonCommentsService };
export var lessonCommentsService = new LessonCommentsService(URLS.LESSON_COMMENTS);
//# sourceMappingURL=lessonComments.service.js.map